import type { ActionBinding } from "./ActionBinding.type"
import createDefaultActionBindings from "./createDefaultActionBindings"

export const actionBindings: ActionBinding[] = createDefaultActionBindings()